import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { EventType } from "../passport/models/passport.models";
import { IBulkPurchaseReceipt, IEventPurchaseDetails } from "./models/bulk-purchase.models";

@Injectable({
  providedIn: 'root',
})
export class StripePurchaseService {
  private url = '';
  constructor(private http: HttpClient) {
    this.url = environment.apiURL;
  }

  public startPaymentSession(eventId: number, eventType: EventType, guestUserIds: number[],emptyTicketCount:number, callbackUrl: string,purchaseTransactionType:string): Observable<any> {
    
    return this.http.post<any>(
      `${this.url}api/stripe-purchase/payment-session`, {
        eventId,
        eventType,
        guestUserIds,
        emptyTicketCount,
        callbackUrl
      },
      { params: { purchaseTransactionType: purchaseTransactionType }}
    )
  }

  public getPaymentReceipt(eventId: number, sessionId: string): Observable<any> {
    return this.http.get<any>(
      `${this.url}api/stripe-purchase/payment-receipts/${eventId}/${sessionId}`
    );
  }

  public getEventPurchaseDetails(eventId: number, eventType: EventType): Observable<IEventPurchaseDetails> {
    return this.http.get<IEventPurchaseDetails>(
      `${this.url}api/stripe-purchase/event-purchase-details/${eventId}/${eventType}`
    );
  }

  public confirmPaymentSession(eventId: number, eventType: EventType, paymentSessionId: string): Observable<IBulkPurchaseReceipt> {
    return this.http.post<IBulkPurchaseReceipt>(
      `${this.url}api/stripe-purchase/payment-session/confirm`,
      {
        eventId,
        eventType,
        paymentSessionId
      }
    )
  }
 public assignTicket(paymentSessionId: string, guestUserId: number): Observable<any> {
    const url = environment.apiURL + 'api/stripe-purchase/assign-ticket';
  
    const data = {
      paymentSessionId,
      guestUserId
    };
    return this.http.post(url, data);
  }

  public removeTicket(paymentSessionId: string, guestUserId: number): Observable<any> {
    const url = environment.apiURL + 'api/stripe-purchase/remove-ticket';
    const options = {
      body: {
        paymentSessionId: paymentSessionId,
        guestUserId: guestUserId
      }
    };
  
    return this.http.request('delete', url, options);
  }
  getSubscriptionDetails(purchaseTransactionType:string): Observable<any> {
    const url = environment.apiURL + `api/stripe-purchase/subscription-purchase-details`;
    return this.http.get(url,{params:{purchaseTransactionType:purchaseTransactionType}});
  }  
}
